/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_Hide_CodeInputs */



/**
* | output |
* | --- |
* | "Hide QR Code" |
*
* @param {Checkin_Qr_Hide_CodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_hide_code = /** @type {((inputs?: Checkin_Qr_Hide_CodeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_Hide_CodeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer le QR Code")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar código QR")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ocultar código QR")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi codice QR")
	return /** @type {LocalizedString} */ ("Hide QR Code")
});